
import { createSlice } from '@reduxjs/toolkit'

export const tctappstoreSlice = createSlice({
  name: 'tctappstore',
  initialState: {
    value: { username: '', rolename : '', emailid : '' , phoneno: '', userimage:'' }
  },
  reducers: {
    dbtctStoreLogin: (state,action) => {
      state.value = action.payload
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
    },
    dbtctStoreLogout: (state, action) => {
      state.value = { value: { username: '', rolename : '', emailid : '' , phoneno: '' ,userimage:''} }
  }
    
  },
})
  

// Action creators are generated for each case reducer function
export const { dbtctStoreLogin, dbtctStoreLogout } = tctappstoreSlice.actions

export default tctappstoreSlice.reducer